/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageOptimize from '@/components/ImageOptimize'
import { BannerType, PageTypeSuffix } from '@/constants'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import type { BannerList, Post, Promotion } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getProductForYou } from '@/utils/endpoint'
import * as pixel from '@/utils/fpixel'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import PostBreadcrumb from '../PostBreadcrumb'
import Recommend from '../Recommend'

const PostDetail = ({
  postDetail,
  hideMenu,
  postCate,
  banner,
}: {
  postDetail: Post
  hideMenu: string
  postCate: Post[]
  banner: BannerList[]
}) => {
  const bannerBlog = useMemo(() => {
    return banner.filter(banner => {
      return banner.type === BannerType.BLOG && banner.status === 1
    })
  }, [banner])
  const router = useRouter()
  const [productForYou, setProductForYou] = useState<Promotion | null>(null)
  useEffect(() => {
    pixel.fbqEvent('ViewContent')
    const fetchProductForYou = async () => {
      const data = await getProductForYou()
      setProductForYou(data)
    }
    fetchProductForYou()
  }, [])
  if (hideMenu) {
    return (
      <div className='postDetailContent mb-[40px] mt-[32px]'>
        <div className='mb-8 mt-3 font-bold italic text-dark-400'>
          {getTranslate(postDetail?.description)}
        </div>
        <div
          className='main-description break-words'
          dangerouslySetInnerHTML={{
            __html: getTranslate(postDetail?.content),
          }}
        ></div>
      </div>
    )
  }
  return (
    <Main
      meta={
        <Meta
          title={
            getTranslate(postDetail?.metaTitle) &&
            getTranslate(postDetail?.metaTitle) !== ''
              ? getTranslate(postDetail?.metaTitle)
              : getTranslate(postDetail?.title)
          }
          description={
            getTranslate(postDetail?.metaDescription) &&
            getTranslate(postDetail?.metaDescription) !== ''
              ? getTranslate(postDetail?.metaDescription)
              : getTranslate(postDetail?.description)
          }
          imageUrl={
            postDetail?.images[0] || process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER
          }
          canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          noIndex={postDetail?.noIndex}
          noFollow={postDetail?.noFollow}
          mobileAlternate={{
            media: 'only screen and (max-width:991px))',
            href:
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
              '',
          }}
        />
      }
    >
      <section className='postDetail min-h-[500px] pb-5'>
        <PostBreadcrumb
          breadcrumbs={postCate}
          title='Tin tức'
          banner={bannerBlog}
          postDetail={postDetail}
        />
        <div className='mt-4 flex '>
          <div className='flex-2 rounded-lg bg-white px-5 py-4 pr-[70px]'>
            <h1 className='text-HeadlineLarge font-bold text-dark-400'>
              {getTranslate(postDetail?.title)}
            </h1>
            <div className='postDetailContent mb-10 mt-3'>
              <div className='mb-4 mt-3 font-bold italic text-dark-400'>
                {getTranslate(postDetail?.description)}
              </div>
              <div
                className='main-description break-words'
                dangerouslySetInnerHTML={{
                  __html: getTranslate(postDetail?.content),
                }}
              ></div>
            </div>
          </div>
          <div></div>
          <div className='sideBar max-w-[25%] flex-4 px-4'>
            <div className='sticky top-[20px]'>
              <div className='mt-1'>
                {postDetail?.relatedPosts.length > 0 &&
                  postDetail?.relatedPosts.map((e: Post, index: number) => (
                    <Link
                      key={index}
                      href={`/${getTranslate(e.slugs.value)}${e.slugs.postfix}${
                        PageTypeSuffix.POST
                      }`}
                    >
                      <div className='mb-[24px] flex flex-col items-center gap-y-[10px]'>
                        <ImageOptimize
                          className='cartImage h-[180px] w-[280px] rounded-lg '
                          src={e?.images[0]}
                          loading='lazy'
                          alt={getTranslate(e.title) || ''}
                          width={88}
                          height={88}
                        />
                        <p className='text-left font-bold'>
                          {getTranslate(e.title)}
                        </p>
                      </div>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Recommend data={productForYou} />
    </Main>
  )
}

export default PostDetail
